import React, { useState } from "react";
import Mentor from "./img/mentorship-program.png";
import HTMLReactParser from "html-react-parser";
import "./style.scss";


export default function MentorShipProgram(props) {
  const Banner = props.data[1];
  const BannerImage = Banner.BannerImage;
  const BannerTitle = Banner.BannerTitle;
  const BannerSubtitle = Banner.BannerSubtitle;
  return (
    <div className="mentor-ship-program">
      <section className="mentor-ship-container">
        <div className="w-100 pt-0 pb-0 position-relative">
          <div className="container">
            <div className="row pt-50 pb-0">
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInLeft">
                <div className="content mentorshipprogramdiv homepageFirstHeader homepageFirstDescription">
                  {HTMLReactParser(BannerTitle)}
                  <br />
                  {HTMLReactParser(BannerSubtitle)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInRight">
                <div
                  className="mckp-img text-center tilt w-100"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                >
                  <img className="img-fluid" src={Mentor} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
